module.exports = __webpack_public_path__ + "img/File-txt.51958170.svg";